import get from 'lodash/get';
import { createSelector, type Selector } from 'reselect';
import type { AppState } from '../app-state.js';
import { NAME } from './constants.js';

export const getSchedule: Selector<AppState, Record<string, string>> = createSelector(
  (state) => state[NAME],
  (scheduleState) => get(scheduleState, 'data', {})
);

export const getShowSchedule: Selector<AppState, boolean> = createSelector(
  (state) => state.router,
  (router) => Boolean(get(router, ['params', 'contentId']))
);
